<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
    <div class="box" :style="{ 'min-height': minHeight }">
      <b-field label="Organisations Nutzer">
        <InputBox
          :space="false"
          :height="userListHeight"
          :maxHeight="userListMaxHeight"
        >
          <b-table :data="userByOrgId" :mobile-cards="false">
            <b-table-column field="first_name" label="Vorname" v-slot="props">
              {{ props.row.first_name }}
            </b-table-column>

            <b-table-column field="last_name" label="Nachname" v-slot="props">
              {{ props.row.last_name }}
            </b-table-column>

            <b-table-column field="email" label="E-Mail" v-slot="props">
              {{ props.row.email }}
            </b-table-column>

            <b-table-column field="type" label="Rolle" v-slot="props">
              <userTag :data="props.row.type" />
            </b-table-column>

            <b-table-column field="type" v-slot="props">
              <router-link
                :to="{
                  name: 'ViewUser',
                  params: { userId: props.row.id },
                }"
              >
                <b-icon icon="arrow-right" icon-pack="fas"></b-icon>
              </router-link>
            </b-table-column>
          </b-table>
        </InputBox>
      </b-field>

      <div class="columns">
        <div class="column"></div>
        <div class="column is-narrow is-flex is-align-items-center">
          Verfügbare Accounts:
        </div>
        <div class="column is-2">
          <BInputWithValidation type="number" v-model="data.user_amount" />
        </div>
      </div>

      <b-field v-if="orgSubs(data.id).length" label="Unter Organisationen">
        <InputBox
          :space="false"
          :height="orgListHeight"
          :maxHeight="orgListMaxHeight"
        >
          <b-table :data="orgSubs(data.id)" :mobile-cards="false">
            <b-table-column field="first_name" label="Name" v-slot="props">
              {{ orgById(props.row).name }}
            </b-table-column>

            <b-table-column field="type" v-slot="props">
              <router-link
                :to="{
                  name: 'ViewOrg',
                  params: { orgId: props.row },
                }"
              >
                <b-icon icon="arrow-right" icon-pack="fas"></b-icon>
              </router-link>
            </b-table-column>
          </b-table>
        </InputBox>
      </b-field>
    </div>
    <!-- <div class="block" v-if="error">
      <b-message type="is-danger">
        {{ error }}
      </b-message>
    </div> -->
    <div class="columns">
      <div class="column"></div>
      <div class="column is-narrow">
        <b-button
          type="is-gold"
          :disabled="invalid"
          @click="handleSubmit(submit)"
        >
          Speichern
        </b-button>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from "vuex";

import BInputWithValidation from "@/components/inputs/BInputWithValidation.vue";
import InputBox from "@/components/helper/InputBox.vue";
import userTag from "@/components/editUser/UserTag.vue";

export default {
  name: "OrgAccounts",
  components: {
    InputBox,
    BInputWithValidation,
    userTag
  },
  props: {
    data: {
      required: true
    },
    minHeight: {
      type: String,
      default: "initial"
    },
    userListHeight: {
      type: String,
      default: "auto"
    },
    userListMaxHeight: {
      type: String,
      default: "initial"
    },
    orgListHeight: {
      type: String,
      default: "auto"
    },
    orgListMaxHeight: {
      type: String,
      default: "initial"
    }
  },
  computed: {
    ...mapGetters({
      orgs: "org/data",
      orgById: "org/dataById",
      orgSubs: "org/sub/dataByParentId",
      users: "user/data"
    }),
    userByOrgId() {
      return this.users.filter(item => item.org_id === this.data.id);
    }
  },
  methods: {
    submit() {
      this.$emit("submit", {
        id: this.data.id,
        user_amount: Number(this.data.user_amount)
      });
    }
  }
};
</script>
